import controller from './dynamic-banner.controller';
import templateBase from './templates/dynamic-banner-base.view.html';

let DynamicBannerComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    dbData : '<',
    dbName : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  return templateBase;

}

export default DynamicBannerComponent;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/banners/dynamic-banner/dynamic-banner.component.js
 **/